import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-gps",
  "use": "icon-gps-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-gps\"><defs><style type=\"text/css\"></style></defs><path d=\"M801.344 153.472A409.6 409.6 0 0 0 511.68 33.216 409.472 409.472 0 0 0 428.16 843.328l85.312 147.456 85.248-147.456a409.6 409.6 0 0 0 322.304-400 409.216 409.216 0 0 0-119.68-289.856zM408.32 353.152H288.064v192.576h72.128V473.472h-32.064v-48.128H408.32v167.488H239.936V305.984H408.32v47.168z m191.744 120.32h-120.32v119.36h-48.256V305.984h168.576v167.488z m183.488-80.128h-48.192v-40.192h-63.168v72.256h111.36v167.488H624.064v-95.36h48.128v48.128h63.168V473.472H624.064V305.984h159.488v87.36z\" p-id=\"28702\" /><path d=\"M479.68 353.152h72.128v72.256H479.68z\" p-id=\"28703\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gps.svg
// module id = dy36
// module chunks = 68